import clsx from "clsx";
import { useState } from "react";
import { useCopyToClipboard } from "usehooks-ts";

export const CopyCellToClipboard: React.FC<{
  value: string;
}> = ({ value }) => {
  const [, copyToClipboard] = useCopyToClipboard();
  const [isCopied, setIsCopied] = useState(false);
  return (
    <button
      className={clsx(
        "px-1",
        isCopied
          ? "opacity-100"
          : "opacity-0 hover:!opacity-60 group-hover:opacity-40"
      )}
      onClick={async () => {
        await copyToClipboard(value);
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      }}
    >
      {isCopied ? (
        <i className="far fa-check" />
      ) : (
        <i className="far fa-clipboard" />
      )}
    </button>
  );
};
